import { ReplaceableComponentsService } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@abp/ng.theme.lepton-x';
import { APP_INITIALIZER } from '@angular/core';
import { SidebarLogoComponent } from './sidebar-logo.component';

export const SIDEBAR_LOGO_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: (replaceableComponents: ReplaceableComponentsService) => () => {
      replaceableComponents.add({
        key: eThemeLeptonXComponents.Logo,
        component: SidebarLogoComponent,
      });
    },
    deps: [ReplaceableComponentsService],
    multi: true,
  },
];
